import { render, staticRenderFns } from "./fauhangreason.vue?vue&type=template&id=2f8e8fab&scoped=true&"
import script from "./fauhangreason.vue?vue&type=script&lang=js&"
export * from "./fauhangreason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8e8fab",
  null
  
)

export default component.exports